import { requestAsync } from "@digitalwing.co/redux-query-immutable";
import endpoints from "api/endpoints";
import { normalize } from "normalizr";
import { offer } from "schemas";

/**
 *
 * @param id {String}
 * @param successCallback {Function}
 * @param errorCallback {Function}
 */
export default ({ id, successCallback, errorCallback }) => {
  return requestAsync({
    url: endpoints.getOfferByIdUrl(id),
    queryKey: endpoints.getOfferByIdUrl(id),
    transform: (response) => response,
    transformResult: (response) => response,
    meta: {
      authToken: true,
      successCallback,
      errorCallback,
    },
    options: {
      headers: {
        Accept: "application/json",
      },
      method: "DELETE",
    },
    update: {
      offer: (_, result) => result,
    },
    updateResult: {
      offer: (_, result) => result,
    },
  });
};
